module.exports = __webpack_public_path__ + "media/how-it-works.5e683e55.mp4";